<template>
  <b-row class="v-center-container">
    <b-col cols="12" class="item pb-3 pb-lg-5 fadeIn" ref="step1">
      <img
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAzMkMyNC44MzY2IDMyIDMyIDI0LjgzNjYgMzIgMTZDMzIgNy4xNjM0NCAyNC44MzY2IDAgMTYgMEM3LjE2MzQ0IDAgMCA3LjE2MzQ0IDAgMTZDMCAyNC44MzY2IDcuMTYzNDQgMzIgMTYgMzJaTTE3LjkyNSAyMi41MjgxSDE1LjU1MzFWMTEuMzA2MkgxNS40OTY5TDEyIDEzLjc2MjVWMTEuNDg0NEwxNS41MzQ0IDlIMTcuOTI1VjIyLjUyODFaIiBmaWxsPSIjMkM3Q0IwIi8+Cjwvc3ZnPgo="
        alt="one"
        class="mr-3"
        width="10%"
      />
      <div>
        <div class="header">{{ $t("signup.tips.h1") }}</div>
        <div class="desc">{{ $t("signup.tips.p1") }}</div>
      </div>
    </b-col>
    <b-col cols="12" class="item pb-3 pb-lg-5" ref="step2">
      <img
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAzMkMyNC44MzY2IDMyIDMyIDI0LjgzNjYgMzIgMTZDMzIgNy4xNjM0NCAyNC44MzY2IDAgMTYgMEM3LjE2MzQ0IDAgMCA3LjE2MzQ0IDAgMTZDMCAyNC44MzY2IDcuMTYzNDQgMzIgMTYgMzJaTTExIDEzLjMxMjVWMTMuMjg0NEMxMSAxMC43OTA2IDEyLjk5NjkgOSAxNS44IDlDMTguNSA5IDIwLjQzMTIgMTAuNjUgMjAuNDMxMiAxMi44NDM4QzIwLjQzMTIgMTQuNDU2MyAxOS40NzUgMTUuNjc1IDE3LjcwMzEgMTcuNDY1NkwxNC4zNTYyIDIwLjc3NVYyMC44MjE5SDIwLjYzNzVWMjIuOEgxMS4xMzEzVjIxLjE2ODhMMTYuMTA5NCAxNi4yMTg4QzE3LjY0NjkgMTQuNjUzMSAxOC4wNjg4IDEzLjk1OTQgMTguMDY4OCAxMi45NDY5QzE4LjA2ODggMTEuODMxMyAxNy4wNjU2IDEwLjk0MDYgMTUuNzI1IDEwLjk0MDZDMTQuMzE4OCAxMC45NDA2IDEzLjI2ODggMTEuOTM0NCAxMy4yNjg4IDEzLjI3NVYxMy4zMTI1SDExWiIgZmlsbD0iIzJDN0NCMCIvPgo8L3N2Zz4K"
        alt="one"
        class="mr-3"
        width="10%"
      />
      <div>
        <div class="header">{{ $t("signup.tips.h2") }}</div>
        <div class="desc">{{ $t("signup.tips.p2") }}</div>
      </div>
    </b-col>
    <b-col cols="12" class="item pb-3 pb-lg-5" ref="step3">
      <img
        src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNiAzMkMyNC44MzY2IDMyIDMyIDI0LjgzNjYgMzIgMTZDMzIgNy4xNjM0NCAyNC44MzY2IDAgMTYgMEM3LjE2MzQ0IDAgMCA3LjE2MzQ0IDAgMTZDMCAyNC44MzY2IDcuMTYzNDQgMzIgMTYgMzJaTTE1Ljk4NzUgMTYuNzcxOUgxNC4zMTg4VjE0Ljk1MzFIMTUuOTVDMTcuMzM3NSAxNC45NTMxIDE4LjI4NDQgMTQuMSAxOC4yODQ0IDEyLjg5MDZDMTguMjg0NCAxMS43MDk0IDE3LjQ1OTQgMTAuOTIxOSAxNS45NDA2IDEwLjkyMTlDMTQuNTQzNyAxMC45MjE5IDEzLjYwNjIgMTEuNzM3NSAxMy41MTI1IDEzLjAwMzFIMTEuMjYyNUMxMS4zOTM4IDEwLjU3NSAxMy4yNTk0IDkgMTYuMDUzMSA5QzE4LjcxNTYgOSAyMC42MDk0IDEwLjQ1MzEgMjAuNjA5NCAxMi41NjI1QzIwLjYwOTQgMTQuMjQwNiAxOS40ODQ0IDE1LjQ1IDE3LjgxNTYgMTUuNzQwNlYxNS43OTY5QzE5Ljg0MDYgMTUuOTQ2OSAyMS4xNTMxIDE3LjE4NDQgMjEuMTUzMSAxOS4wNjg3QzIxLjE1MzEgMjEuNDU5NCAxOC45NzgxIDIzLjA3MTkgMTYuMDI1IDIzLjA3MTlDMTMuMDUzMSAyMy4wNzE5IDExLjEyMTkgMjEuNDQwNiAxMSAxOS4wMzEySDEzLjMwNjJDMTMuNDE4NyAyMC4yNjg3IDE0LjQzMTIgMjEuMDkzOCAxNi4wNDM4IDIxLjA5MzhDMTcuNiAyMS4wOTM4IDE4LjY5NjkgMjAuMjIxOSAxOC42OTY5IDE4Ljk3NUMxOC42OTY5IDE3LjYwNjIgMTcuNjY1NiAxNi43NzE5IDE1Ljk4NzUgMTYuNzcxOVoiIGZpbGw9IiMyQzdDQjAiLz4KPC9zdmc+Cg=="
        alt="one"
        class="mr-3"
        width="10%"
      />
      <div>
        <div class="header">{{ $t("signup.tips.h3") }}</div>
        <div class="desc">{{ $t("signup.tips.p3") }}</div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
// @ is an alias to /src
import { addClass, removeClass } from "@/components/utils.js";

export default {
  name: "SignSteps",
  props: {
    step: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      step1: null,
      step2: null,
      step3: null,
    };
  },
  methods: {
    jump(step) {
      switch (step) {
        case 1:
          removeClass(this.step2, "fadeIn");
          removeClass(this.step3, "fadeIn");
          addClass(this.step1, "fadeIn");
          break;
        case 2:
          removeClass(this.step1, "fadeIn");
          removeClass(this.step3, "fadeIn");
          addClass(this.step2, "fadeIn");
          break;
        default:
      }
    },
  },
  watch: {
    step(to) {
      this.jump(to);
    },
  },
  mounted() {
    this.step1 = this.$refs.step1;
    this.step2 = this.$refs.step2;
    this.step3 = this.$refs.step3;
    this.jump(this.step);
  },
};
</script>

<style scoped>
@import "../../common.scss";
@import "../../animation.scss";

.item {
  display: flex;
  opacity: 0.65;
}
.item img {
  height: 42px;
  width: 42px;
  margin-top: 5px;
}
.item .header {
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 0.3em;
}
.item .desc {
  font-size: 0.85em;
  line-height: 1.4em;
}
</style>



